import controller from './select.controller'
import template from './select.html'

const SelectComponent = {
	bindings: {
		selectedValue: '<',
		listValue: '<',
		dispalyField: '<',
		idField: '<',
		basicMode: '<',
		onChange: '&'
	},
	controller,
	template,
};

export default SelectComponent;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/select/select.component.js